export const dynamicDonationResourcePath = (
  path,
  { whitelabelURL },
  pathReplacement = () => '',
) => {
  if (whitelabelURL) {
    const pathRoute = Routes.donations_path();

    path = path.replace(pathRoute, pathReplacement(pathRoute));
  }

  return path;
};

export const donationBasePath = (route) => (route === '' ? '/' : route); // route is empty if white label donations activated
